<p-card data-cy="insurane-requirements-widget">
  <h3 class="mt-0 mb-4" data-cy="title">Update your product usage</h3>
  <div class="-mb-4">
    <div class="grid grid-nogutter pt-3 xl:my-0 xl:-mx-3">
      <div class="col-12 xl:col-7 xl:py-0 xl:px-3">
        <app-form-field
          *ngFor="let dohControl of dohForm?.controls; let i = index"
          [control]="asFormControl(dohControl.get('doh')!)"
          [name]="'items-' + i + '-doh'"
          [label]="'For ' + initialDaysOnHand[i].itemDescription + ', how many days will your supply last?'"
          [labelHint]="'Our record shows ' + initialDaysOnHand[i].estimatedDaysOnHand + ' days'"
          errorLabel="Number of days on hand"
          type="input"
          [limitWidth]="true"
          inputType="number"
          inputMode="numeric"
          [min]="0"
        ></app-form-field>
        <app-form-field
          *ngIf="ouDaysOnHandForm"
          [control]="asFormControl(ouDaysOnHandForm?.get('ouDaysOnHand')!)"
          name="ou-days-on-hand-input"
          label="Enter your days on hand for the items above."
          errorLabel="Number of days on hand"
          type="input"
          [limitWidth]="true"
          inputType="number"
          inputMode="numeric"
          [min]="0"
        ></app-form-field>
      </div>
      <div
        *ngIf="frequenciesForm"
        class="col-12"
        [ngClass]="dohForm || ouDaysOnHandForm ? 'xl:col-5 xl:py-0 xl:px-3' : ''"
      >
        <app-form-field
          *ngIf="(frequenciesRequired$ | async)?.cgmSiteChgFreqRequired === true"
          [control]="asFormControl(frequenciesForm.get('cgmSiteChgFreq')!)"
          name="cgmSiteChgFreq"
          label="How often, in days, do you change your CGM site?"
          errorLabel="CGM Site Change Frequency"
          type="input"
          [limitWidth]="true"
          inputType="number"
          inputMode="decimal"
        ></app-form-field>
        <app-form-field
          *ngIf="(frequenciesRequired$ | async)?.pumpSiteChgFreqRequired === true"
          [control]="asFormControl(frequenciesForm.get('pumpSiteChgFreq')!)"
          name="pumpSiteChgFreq"
          label="How often, in days, do you change your pump site?"
          errorLabel="Pump Site Change Frequency"
          type="input"
          [limitWidth]="true"
          inputType="number"
          inputMode="decimal"
        ></app-form-field>
        <app-form-field
          *ngIf="(frequenciesRequired$ | async)?.patientTestFreqRequired === true"
          [control]="asFormControl(frequenciesForm.get('patientTestFreq')!)"
          name="patientTestFreq"
          label="How often per day do you test your blood sugar?"
          errorLabel="Testing Frequency"
          type="input"
          [limitWidth]="true"
          inputType="number"
          inputMode="numeric"
        ></app-form-field>
      </div>
    </div>
  </div>
</p-card>
